module.exports = __webpack_public_path__ + "static/img/female-bg-es.85604871.png";